import { createAction, props } from "@ngrx/store";
import { IReleaseNotes } from "../../models/release-notes";
import IUser from "../../models/user";

const prefix = "[Add Release Notes Page]";

export const loadPage = createAction(`${prefix} Load Page`);
export const populateUser = createAction(
  `${prefix} Populate User`,
  props<{ user: IUser }>(),
);
export const requestAddReleaseNotes = createAction(
  `${prefix} Request Add Release Notes`,
  props<{ releaseNotes: IReleaseNotes }>(),
);
export const requestReleaseNotesById = createAction(
  `${prefix} Request Release Notes By Id`,
  props<{ id: string }>(),
);
